export const META_DESCRIPTION_CHAR_LIMIT = 160;
